import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { CI_CAPABILITIES } from '../capabilities';
import { CI_FIELD_KEYS } from '../fields';
import { CI_MODULES } from '../modules';
import { ciMigrations } from './migrations';
import { buildCiResourceConfigs, buildContainerDisplayDescriptors, pickCiPresetFields, serializeContainerApiBody } from './projections';
import { type CiApiPayload, type CiSpec, CiSpecSchema } from './schema';
import { ciFromForm, ciGetInitialFormValues, ciToForm } from './spec';
import { assertCiSubmitReady } from './validateSubmit';

export const ciHeadless = createDeployPluginHeadless<CiSpec, CiApiPayload, (typeof CI_FIELD_KEYS)[number]>({
  code: 'ContainerInstance',
  fieldKeys: CI_FIELD_KEYS,
  modules: CI_MODULES,
  capabilities: CI_CAPABILITIES,
  schema: CiSpecSchema,
  fromForm: ciFromForm,
  toForm: ciToForm,
  getInitialFormValues: ciGetInitialFormValues,
  assertSubmitReady: assertCiSubmitReady,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeContainerApiBody,
      skuPreset: pickCiPresetFields,
      buildDisplayDescriptors: buildContainerDisplayDescriptors,
      skuResources: buildCiResourceConfigs,
    },
  },
  migrations: ciMigrations,
});

export const ciPipeline = ciHeadless.pipeline;

export {
  buildContainerInstanceDeliveryMetadata,
  buildContainerInstanceOrderDeliveryMetadata,
  buildContainerInstanceSubmitPayload,
} from './deliveryMetadata';
export type {
  BuildContainerInstanceDeliveryMetadataInput,
  BuildContainerInstanceOrderDeliveryMetadataContext,
  ContainerInstanceDeliveryMetadata,
} from './deliveryMetadata';
